const API_BASE = '/api/v1/post-templates';

function getAuthHeaders() {
  const token = localStorage.getItem('tkn');
  return token ? { Authorization: `Bearer ${token}` } : {};
}

export async function getPostTemplates() {
  const res = await fetch(API_BASE, { headers: { ...getAuthHeaders() } });
  const data = await res.json();
  if (!data.success) throw new Error(data.error || 'Failed to fetch post templates');
  return data.templates;
}

export async function getPostTemplateById(id) {
  const res = await fetch(`${API_BASE}/${id}`, { headers: { ...getAuthHeaders() } });
  const data = await res.json();
  if (!data.success) throw new Error(data.error || 'Failed to fetch post template');
  return data.template;
}

export async function createPostTemplate(template) {
  const res = await fetch(API_BASE, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getAuthHeaders() },
    body: JSON.stringify(template),
  });
  const data = await res.json();
  if (!data.success) throw new Error(data.error || 'Failed to create post template');
  return data.template;
}

export async function updatePostTemplate(id, template) {
  const res = await fetch(`${API_BASE}/${id}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getAuthHeaders() },
    body: JSON.stringify(template),
  });
  const data = await res.json();
  if (!data.success) throw new Error(data.error || 'Failed to update post template');
  return data.template;
}

export async function deletePostTemplate(id) {
  const res = await fetch(`${API_BASE}/${id}`, {
    method: 'DELETE',
    headers: { ...getAuthHeaders() },
  });
  const data = await res.json();
  if (!data.success) throw new Error(data.error || 'Failed to delete post template');
  return true;
}

export async function publishPost(id, post) {
  const res = await fetch(`${API_BASE}/${id}/publish`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getAuthHeaders() },
    body: JSON.stringify(post),
  });
  const data = await res.json();
  if (!data.success) throw new Error(data.error || 'Failed to publish post');
  return data;
}

export async function schedulePost(id, post) {
  const res = await fetch(`${API_BASE}/${id}/schedule`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getAuthHeaders() },
    body: JSON.stringify(post),
  });
  const data = await res.json();
  if (!data.success) throw new Error(data.error || 'Failed to schedule post');
  return data;
}
